import { ConfirmComponent } from './../confirm/confirm.component';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionService } from '@app/core/services/subscription/subscription.service';
import { SubscriptionStatusEnum } from '@app/core/services/subscription/models/enum/subscription-status.enum';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '@app/core/services/util/notification.service';


@Component({
    selector: 'subscription-actions',
    templateUrl: './subscription-actions.component.html',
    styleUrls: ['./subscription-actions.component.css'],
    standalone: false
})
export class SubscriptionActionsComponent implements OnInit {

  @Input() status: string;

  @Input() showBoutton: boolean;

  @Input() subcriptionId: number;

  @Input() mobilityAccountId: number;

  @Input() serviceReference: string;

  possibleStatuses: string[];
  @Output() onUpdateSubscription = new EventEmitter<boolean>();

  @Output() onCancel = new EventEmitter<boolean>();

  SubscriptionStatusEnum = SubscriptionStatusEnum;

  loaded:boolean = false;

  constructor(private subscriptionService: SubscriptionService,
              private notificationService: NotificationService,
              private translate: TranslateService,
              private dialog: MatDialog) { }

  ngOnInit() {
    this.getAvailableStatuses()
  }


  cancel(){
    this.onCancel.emit(true);
  }


  getAvailableStatuses(){
    if (this.status == 'AWAITING_REMOVAL') {
      this.possibleStatuses = ['CANCEL'];
        this.loaded= true;
    }
  }

  onClick(event){
    this.translate.get(['ACTIONS.CANCEL', 'ACTIONS.CONFIRM', 'STATUS.SERVICE.ACTIONS.POPUP.'+event, 'STATUS.SERVICE.ACTIONS.POPUP.TITLE']).subscribe(
      res => {
        const dialogRef = this.dialog.open(ConfirmComponent, {
          panelClass: 'modal',
          width: '40%',
          data: {
            title: res['STATUS.SERVICE.ACTIONS.POPUP.TITLE'],
            message: res['STATUS.SERVICE.ACTIONS.POPUP.'+event],
            confirmButton: res['ACTIONS.CONFIRM'],
            closeButton: res['ACTIONS.CANCEL']
          }
        });

        dialogRef.afterClosed().subscribe(
          res => {
            this.status == 'AWAITING_REMOVAL' ? event = SubscriptionStatusEnum.ACTIVE: event;
          }
        )
      }
    )

  }
}
